import { fromJsonArray } from 'src/core/utils';
import ActionDTOAdmin from '../ActionDTOAdmin';
import ArticleGroup from './ArticleGroup';

export default class Article {
    public id: string;
    public name: string;
    public localizedName: string;
    public articleGroup: ArticleGroup;
    public articleNumber: string;
    public discriminator: string;
    public colli: number;
    public colliEntity: string;
    public coffeeAmount: number;
    public positionWeight: number;
    public stock: number;
    public validFrom: Date;
    public validTo: Date;
    public incompleteConfigurationReasons: String[];
    public possibleActions: ActionDTOAdmin[];

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.localizedName = json.localizedName;
        this.articleGroup = new ArticleGroup(json.articleGroup);
        this.articleNumber = json.articleNumber;
        this.discriminator = json.discriminator;
        this.colli = json.colli;
        this.colliEntity = json.colliEntity;
        this.coffeeAmount = json.coffeeAmount;
        this.positionWeight = json.positionWeight;
        this.stock = json.stock;
        this.validFrom = new Date(json.validFrom);
        this.validTo = new Date(json.validTo);
        this.incompleteConfigurationReasons = fromJsonArray(String, json.incompleteConfigurationReasons);
        this.possibleActions = fromJsonArray(ActionDTOAdmin, json.possibleActions);
    }

    public getFullArticleNumber(): string {
        return this.articleGroup.articleType.id + '' + this.articleGroup.groupId + '' + this.articleNumber;
    }
}
